import { useQuery } from 'react-query';
import { client } from '@frontend/features/common/services';
import { providerNames } from './providerNames';

export function useProviderNames() {
  const query = useQuery(
    ['hotel-provider-display-names'],
    async () => (await client.get('content-extractor/suppliers', { params: { currentPage: 1, pageSize: 10000 } })).data,
    { retry: false, staleTime: 60000 },
  );
  return { ...query, names: providerNames(query.isError ? undefined : query.data) };
}
